import { render, staticRenderFns } from "./banner_home.vue?vue&type=template&id=146ad359&scoped=true&"
import script from "./banner_home.vue?vue&type=script&lang=js&"
export * from "./banner_home.vue?vue&type=script&lang=js&"
import style0 from "./banner_home.vue?vue&type=style&index=0&id=146ad359&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ad359",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/app/components/banner.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
